import React from 'react';
import { Button } from './ui/button';
import { Trash2 } from 'lucide-react';

/**
 * Reusable mass action toolbar
 * Used in: Team, Assets, Bookings pages
 */
const MassActionToolbar = ({ 
  selectedCount, 
  onSelectAll, 
  onDeselectAll, 
  onDelete,
  itemName = 'item',
  showDelete = true
}) => {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex flex-wrap items-center gap-3">
      <span className="text-sm font-medium text-gray-700">
        {selectedCount} {itemName}{selectedCount !== 1 ? 's' : ''} selected
      </span>
      <div className="flex gap-2">
        <Button
          size="sm"
          variant="outline"
          onClick={onSelectAll}
          className="text-xs"
        >
          Select All
        </Button>
        <Button
          size="sm"
          variant="outline"
          onClick={onDeselectAll}
          className="text-xs"
        >
          Deselect All
        </Button>
        {showDelete && selectedCount > 0 && (
          <Button
            size="sm"
            onClick={onDelete}
            className="bg-red-600 hover:bg-red-700 text-white text-xs"
          >
            <Trash2 className="w-3 h-3 mr-1" />
            <span className="hidden sm:inline">Delete Selected</span>
            <span className="sm:hidden">Delete</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default MassActionToolbar;
